export const keyMapping = {
	sku: 'SKU',
	supplier: 'Supplier',
	sumOfTotalSpend: 'Purchased Amount',
	lpp: 'Last Price Paid',
	avgUnitPrice: 'PO Wt.Avg Unit Price',
	originCountry: 'Origin Country',
	skU_Description: 'SKU Description',
	business_Unit: 'Business Unit',
};
